export default __webpack_public_path__ + "static/media/1271.84bd7dd5.png";